/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-eye-view': {
    width: 14,
    height: 15,
    viewBox: '0 0 14 15',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M7 4.172c-2.551 0-4.802 1.054-6.728 3.146L0 7.613l.218.344C1.581 10.105 3.86 11.172 7 11.172c3.14 0 5.419-1.067 6.782-3.215L14 7.613l-.272-.295C11.802 5.226 9.551 4.172 7 4.172zm1.988 1.254c1.313.348 2.522 1.055 3.63 2.125l.178.176-.041.057c-.896 1.186-2.186 1.933-3.886 2.235A2.995 2.995 0 0 0 10 7.672c0-.894-.391-1.697-1.012-2.246zm-3.976 0C3.699 5.774 2.49 6.48 1.382 7.55l-.179.176.042.057c.896 1.186 2.186 1.933 3.886 2.235A2.995 2.995 0 0 1 4 7.672c0-.894.391-1.697 1.012-2.246zM7 5.672a2 2 0 1 1 0 4 2 2 0 0 1 0-4z" _fill="#515151"/>'
  }
})
